import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import ManagedInput from 'components/form/managed_input';
import SubsectionItem from 'bundles/backoffice/contacts/forms/subsection_item';
import { getOption, getOptions, getInlineStyles, getPortaledMenuProps } from 'helpers/react_select_helpers';
import { inlineStyleOverrides } from 'bundles/backoffice/contacts/forms/react_select_helpers';

export default class PhoneNumber extends React.Component {
  static propTypes = {
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    phoneNumber: PropTypes.shape({
      extension: PropTypes.string,
      index: PropTypes.number.isRequired,
      label: PropTypes.string,
      number: PropTypes.string,
      primary: PropTypes.bool
    }).isRequired,
    onChange: PropTypes.func.isRequired
  }

  handleChange = (changes) => {
    this.props.onChange(changes, this.props.phoneNumber);
  }

  handleLabelChange = ({ label }) => {
    this.props.onChange({ label }, this.props.phoneNumber);
  }

  handleDelete = () => {
    this.props.onChange({ _destroy: true }, this.props.phoneNumber);
  }

  makePrimary = () => {
    this.props.onChange({ primary: true }, this.props.phoneNumber);
  }

  render() {
    const { extension, label, number, primary } = this.props.phoneNumber;

    return (
      <SubsectionItem
        label="Phone/Fax"
        primary={primary}
        onPrimaryChange={this.makePrimary}
        onRemove={this.handleDelete}
      >
        <div className="d-flex justify-content-between align-items-center">
          <Select
            {...getPortaledMenuProps(getInlineStyles(inlineStyleOverrides))}
            name="label"
            options={getOptions(this.props.labels)}
            value={getOption(label)}
            onChange={this.handleLabelChange}
          />

          <ManagedInput
            className="form-control rounded-0 flex-fill"
            name="number"
            placeholder="Ex. 321-330-5560"
            value={number}
            onChange={this.handleChange}
          />

          <ManagedInput
            className="form-control rounded-0 ms-3"
            name="extension"
            placeholder="Ext."
            style={{ width: '50px' }}
            value={extension}
            onChange={this.handleChange}
          />
        </div>
      </SubsectionItem>
    );
  }
}
